export default __webpack_public_path__ + "static/anders-heijlsberg-ff936c39721f26255cb2e1da76a15ab0.jpg";